import { TOOL_ICONS as toolConfigIcons } from '@repo/studio-tool-config/tool-icons'

export const TOOL_ICONS = toolConfigIcons
